export function setJDJRNativeHeaderColor(startColor, endColor) {
  try {
    if (!endColor && startColor) {
      endColor = startColor;
    }
    if (startColor && endColor && $.device && $.device.jdjr && window.jsBridgeV3) {
      const stt = setTimeout(() => {
        clearTimeout(stt);
        window.jsBridgeV3.onReady().then(api => {
          api.jsToGetResp(function() {}, {
            type: 3,
            colorArr: [startColor, endColor]
          });
        });
      }, 10);
    }
  } catch (error) {
    console.log(error);
  }
}
